export enum BookingSelectOption {
  This = "This",
  All = "All",
  Future = "Future"
}

export type Messages = Partial<Record<BookingSelectOption, React.ReactNode>>;
